module.exports = __webpack_public_path__ + "img/left-indent-02.4af83d8f.svg";